<template>
  <div>
    <strong style="font-size: 18px">Order Information</strong>
    <v-select
      :disabled="disableStatusSelect"
      :items="status"
      v-model="order_detail.order_status"
      hide-details
      item-text="name"
      item-value="value"
      label="Status"
    ></v-select>
    <div class="text-xs-left mt-3">
      <v-layout row wrap>
        <v-flex xs6 style="position: relative; border-bottom: 1px solid">
          <v-text-field
            slot="activator"
            v-model="order_date.value"
            label="Order start date: "
            readonly
            hide-details
            :disabled="isEditOrder"
            v-if="showReadonlyStart"
          ></v-text-field>
          <v-menu
            :close-on-content-click="false"
            v-model="order_date_menu"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
            class="mt-1"
            v-if="showEditableStart"
          >
            <v-text-field
              slot="activator"
              v-model="order_date.value"
              label="Order start date: "
              readonly
              hide-details
            ></v-text-field>
            <v-date-picker
              :min="moment().format('YYYY-MM-DD')"
              v-model="order_date.value"
              color="#333"
              no-title
              @input="order_date_menu = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex
          xs5
          style="position: relative; border-bottom: 1px solid"
          class="ml-1"
        >
          <span style="font-size: 12px" v-if="showEditableStart"
            >Order start time:</span
          >
          <v-text-field
            slot="activator"
            :value="order_time.value.HH + ':' + order_time.value.mm"
            label="Order start time"
            readonly
            hide-details
            v-if="showReadonlyStart"
            :disabled="isEditOrder"
          ></v-text-field>
          <vue-timepicker
            hide-clear-button
            v-if="showEditableStart"
            format="HH:mm"
            v-model="order_time.value"
            style="width: 100%"
          ></vue-timepicker>
        </v-flex>
      </v-layout>
    </div>
    <div class="text-xs-left mt-3">
      <v-layout row wrap>
        <v-flex xs6 style="position: relative; border-bottom: 1px solid">
          <v-text-field
            slot="activator"
            v-model="order_end_date.value"
            label="Order end date: "
            readonly
            hide-details
            v-if="showReadonlyEnd"
          ></v-text-field>
          <v-menu
            :close-on-content-click="false"
            v-model="order_end_date_menu"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
            class="mt-1"
            v-if="showEditableEnd"
          >
            <v-text-field
              slot="activator"
              v-model="order_end_date.value"
              label="Order end date: "
              readonly
              hide-details
            ></v-text-field>
            <v-date-picker
              :min="moment().format('YYYY-MM-DD')"
              v-model="order_end_date.value"
              color="#333"
              no-title
              @input="order_end_date_menu = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex
          xs5
          style="position: relative; border-bottom: 1px solid"
          class="ml-1"
        >
          <span style="font-size: 12px" v-if="showEditableEnd"
            >Order end time:</span
          >
          <v-text-field
            slot="activator"
            :value="order_end_time.value.HH + ':' + order_end_time.value.mm"
            label="Order end time"
            readonly
            hide-details
            v-if="showReadonlyEnd"
          ></v-text-field>
          <vue-timepicker
            hide-clear-button
            v-if="showEditableEnd"
            format="HH:mm"
            v-model="order_end_time.value"
            style="width: 100%"
          ></vue-timepicker>
        </v-flex>
      </v-layout>
    </div>
    <v-layout row class="mt-3" wrap>
      <v-flex xs12 class="my-3">
        <div class="text-xs-left">
          <label class="field-disable-title">Ordered when</label>
          <br />
          <div class="field-disable-data">
            {{ moment(order_detail.create_at) }}
          </div>
        </div>
      </v-flex>
      <v-flex xs6 class="my-3">
        <div class="text-xs-left">
          <label class="field-disable-title">Pay by</label>
          <br />
          <div class="field-disable-data">
            {{ paymentTypeText }}
          </div>
        </div>
      </v-flex>
      <v-flex xs6 class="my-3" v-if="canChangeToCOD">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              :loading="changingToCOD"
              small
              depressed
              outline
              color="#1976d2"
              class="mt-2 btn-change-cod"
              @click="handleChangeToCOD"
            >
              <v-icon left small class="mr-1">mdi-cash</v-icon>
              <span class="hidden-xs-only">Switch to COD</span>
              <span class="hidden-sm-and-up">COD</span>
            </v-btn>
          </template>
          <span>{{ "Change payment method to Cash on Delivery" }}</span>
        </v-tooltip>
      </v-flex>
      <v-flex xs6 class="my-3">
        <div class="text-xs-left">
          <label class="field-disable-title">Order area</label>
          <br />
          <div class="field-disable-data">
            {{ order_detail.order_districts_name }}
          </div>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row class="my-3" v-if="order_detail.order_payment_method == 1">
      <v-flex xs12 class="ml-1">
        <span class="body__tag--auto_transfer green">Auto Transfer</span>
      </v-flex>
    </v-layout>

    <v-layout
      row
      class="my-3"
      v-else-if="order_detail.order_payment_method == 2"
    >
      <v-flex xs12 class="ml-1">
        <span class="body__tag--pay_at_store red">Pay at store</span>
      </v-flex>
    </v-layout>
    <v-layout
      row
      class="my-3"
      v-else-if="order_detail.order_payment_method == 3"
    >
      <v-flex xs12 class="ml-1">
        <span class="body__tag--pay_at_store red">Pay at store (Partner)</span>
      </v-flex>
    </v-layout>
    <storeInformation
      :order_detail_position="order_detail.order_position"
      v-for="(info, index) in order_detail.order_store"
      :key="info.store_id"
      :info="info"
      :index="index"
      :transfer_time="transfer_time"
      :transfer_date="transfer_date"
      @viewIMG="$emit('viewIMG', $event)"
    />

    <v-layout row wrap>
      <v-flex xs12 class="mt-3">
        <v-textarea
          v-if="order_status_id != 6 && order_status_id != 7"
          :disabled="isTransferNoteDisabled"
          v-model="order_detail.order_transfer_note"
          hide-details
          rows="2"
          label="Note to rider :"
        ></v-textarea>
        <div class="text-xs-left" v-if="showReadonlyTransferNote">
          <label class="field-disable-title">Note to rider :</label>
          <br />
          <div class="field-disable-data">
            {{ order_detail.order_transfer_note }}
          </div>
        </div>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-textarea
          v-model="order_detail.order_note"
          :disabled="isEditOrder || order_detail.order_status == 7"
          hide-details
          rows="2"
          label="Admin note :"
        ></v-textarea>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import storeInformation from "./Transfer/StoreInformation.vue";
import { mapState, mapGetters } from "vuex";
import Swal from "sweetalert2";
export default {
  props: [
    "order_detail",
    "order_date",
    "order_time",
    "order_end_time",
    "order_end_date",
    "transfer_time",
    "transfer_date",
  ],
  data() {
    return {
      order_end_date_menu: false,
      order_date_menu: false,
      menu2: false,
      status: [
        { name: "Order made", value: 1 },
        { name: "In queue", value: 2 },
        { name: "Cooking", value: 3 },
        { name: "Ready to pick up", value: 4 },
        { name: "On the way", value: 5 },
        { name: "Completed", value: 6 },
      ],
      pay: [
        { name: "Cash", value: 1 },
        { name: "Credit card", value: 2 },
      ],
      pay_status: [
        { name: "Paid", value: 2 },
        { name: "Not pay", value: 1 },
      ],
      changingToCOD: false,
    };
  },
  components: {
    VueTimepicker,
    storeInformation,
  },
  computed: {
    ...mapState({
      order_status_id: (state) => state.fetchOrderListBack.order_status_id,
    }),
    ...mapGetters({
      isEditOrder: "isEditOrder",
    }),
    isFinalStatus() {
      return this.order_status_id == 6 || this.order_status_id == 7;
    },
    canOverride() {
      return this.$store.state.permission.order.edit_view == 3;
    },
    disableStatusSelect() {
      return (
        (this.isFinalStatus && !this.canOverride) ||
        this.order_status_id == 0 ||
        this.isEditOrder
      );
    },
    showEditableStart() {
      return (!this.isFinalStatus && !this.isEditOrder) || this.canOverride;
    },
    showReadonlyStart() {
      return (this.isFinalStatus && !this.canOverride) || this.isEditOrder;
    },
    showEditableEnd() {
      return (!this.isFinalStatus && !this.isEditOrder) || this.canOverride;
    },
    showReadonlyEnd() {
      return (this.isFinalStatus && !this.canOverride) || this.isEditOrder;
    },
    paymentTypeText() {
      const map = {
        1: "Cash",
        2: "Credit card",
        3: "PromptPay",
        4: "Cryptocurrency",
        5: "AR",
      };
      return map[this.order_detail.order_payment_type] || "";
    },
    isTransferNoteDisabled() {
      return (this.isFinalStatus && !this.canOverride) || this.isEditOrder;
    },
    showReadonlyTransferNote() {
      return this.isFinalStatus && !this.canOverride;
    },
    canChangeToCOD() {
      // Show button only if current payment type is not Cash (1) and order not completed/cancelled (6/7) and not editing
      const disallowedStatuses = [6, 7];
      return (
        this.order_detail &&
        this.order_detail.order_payment_type != 1 &&
        !disallowedStatuses.includes(this.order_status_id) &&
        !this.isEditOrder
      );
    },
  },
  methods: {
    selectDate(event) {
      this.$emit("setOrderDate", event);
      this.menu2 = false;
    },
    async handleChangeToCOD() {
      if (this.changingToCOD) return;
      const confirmResult = await Swal.fire({
        icon: "question",
        title: "Change payment to COD?",
        text: "This will switch the payment method to Cash on Delivery.",
        showCancelButton: true,
        confirmButtonText: "Yes, change",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#1976d2",
      });
      if (!confirmResult.isConfirmed) return;
      this.changingToCOD = true;
      try {
        const province = this.$route.params.province || null;
        if (!province) {
          Swal.fire("Error", "Province not found for this order", "error");
          return;
        }
        const res = await this.$store.dispatch(
          "fetchOrderListBack/changeOrderPaymentToCOD",
          {
            province,
            order_id: this.order_detail.order_id,
          }
        );
        if (res && res.order_already_paid) {
          Swal.fire({
            icon: "warning",
            title: "Cannot change to COD",
            text: "This order has already been paid and cannot be switched to Cash on Delivery.",
            confirmButtonText: "OK",
          });
        } else if (res === false) {
          Swal.fire(
            "Failed",
            "Unable to change payment type. Please try again.",
            "error"
          );
        } else {
          this.$set(this.order_detail, "order_payment_type", 1);
          Swal.fire(
            "Success",
            "Order payment type changed to Cash On Delivery.",
            "success"
          );
          this.$emit("cloneOrder");
        }
      } catch (e) {
        console.error(e);
        Swal.fire(
          "Error",
          "Unexpected error while changing payment type.",
          "error"
        );
      } finally {
        this.changingToCOD = false;
      }
    },
  },
};
</script>

<style scoped>
.body__tag--pay_at_store {
  font-size: 18px;
  color: white;
  padding: 5px 10px;
  border-radius: 10px;
}
.body__tag--auto_transfer {
  font-size: 18px;
  color: white;
  padding: 5px 10px;
  border-radius: 10px;
}
.field-disable-title {
  color: #9e9e9e;
  font-size: 12px;
}
.field-disable-data {
  color: #9e9e9e;
  font-size: 16px;
}
.btn-change-cod {
  border: 1px dashed #1976d2 !important;
  background: #e3f2fd !important;
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0.5px;
}
.btn-change-cod:hover {
  background: #bbdefb !important;
}
.btn-change-cod .v-icon {
  color: #1976d2 !important;
}
.btn-change-cod span {
  color: #1976d2 !important;
}
</style>
